import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { GetInstructorsPendingLetterResult } from '../../api/get-instructors-pending-letter/getInstructorsPendingLetter.types';
import type { UseInstructorsPendingLetterParams } from './useInstructorsPendingLetter.types';

import { getInstructorsPendingLetter } from '../../api/get-instructors-pending-letter/getInstructorsPendingLetter';

export function useInstructorsPendingLetter(
  params: UseInstructorsPendingLetterParams
): UseQueryResult<GetInstructorsPendingLetterResult, Error> {
  return useQuery<GetInstructorsPendingLetterResult, Error>({
    queryKey: ['instructors', 'pending-letter', params.customerId],
    queryFn: (): Promise<GetInstructorsPendingLetterResult> =>
      getInstructorsPendingLetter(params.customerId),
    enabled: !!params.customerId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
